<template>
  <div>
    <v-card>
      <v-toolbar
        flat
        color="primary"
        dark
        dense
      >
        <v-icon left>mdi-account-group</v-icon>
        Users
        <v-spacer />
        <v-btn
          dark
          color="success"
          round
          @click="addUser()"
        >
          <v-icon dark left>add</v-icon>
          New User
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-layout
          row wrap
        >
          <v-flex
            sm12
            md3
            style="padding:0 5px 0 5px;"
          >
            <v-card>
              <v-toolbar
                class="primary-color"
                dense
                flat
                dark
              >
                Search &amp; Filtering
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  v-model="searchText"
                  append-icon="search"
                  label="Search Text"
                  single-line
                  hide-details
                  @blur="search"
                  v-on:keyup.enter="search"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn
                  @click="searchText='';search()"
                >
                  Clear
                </v-btn>
                <v-btn
                  color="primary"
                  @click="search"
                >
                  Search
                </v-btn>
                <v-spacer/>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex
            sm12
            md9
          >
            <v-card>
              <v-data-table
                :items="users"
                :headers="headers"
                :pagination.sync="pagination"
                :total-items="totalUsers"
                :rows-per-page-items="paginationStrings"
                :loading="loading"
                disable-initial-sort
              >
                <template slot="no-data">
                  <tr>
                    <td colspan="3">
                      <div style="text-align:center;padding:25px;">
                        <v-icon size="125px">find_in_page</v-icon>
                        <h3>No Results</h3>
                      </div>
                    </td>
                  </tr>
                </template>
                <template
                  slot="items"
                  slot-scope="props"
                >
                  <tr :class="{ 'disabled-user': !props.item.is_active }"
                        @click="edit(props.item.id)"
                        style="cursor:pointer;">
                    <td>
                      <div
                        v-if="props.item.first_name || props.item.last_name"
                        style="text-overflow: ellipsis;"
                      >
                        <b>{{ props.item.first_name }} {{ props.item.last_name }}</b>
                      </div>
                      <div
                        v-else
                        style="opacity: 0.5;"
                      >
                        [ No Name ]
                      </div>
                      <div
                        v-if="props.item.email"
                        style="text-overflow: ellipsis;overflow: hidden;"
                      >
                        {{ props.item.email }}
                      </div>
                    </td>
                    <td
                      style="text-overflow: ellipsis;overflow: hidden;"
                    >
                      {{ props.item.username }}
                    </td>
                    <td class="justify-center layout px-0">
                      <v-icon
                        small
                        class="mr-2"
                        @click="edit(props.item.id)"
                      >
                        edit
                      </v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-fade-transition>
      <div
        v-if="editing"
        class="v-overlay v-overlay--active"
        style="z-index: 201;"
      ></div>
    </v-fade-transition>
    <v-dialog
      v-model="editing"
      persistent
      fullscreen
      transition="dialog-bottom-transition"
      content-class="right-held"
      :hide-overlay="false"
    >
      <User
        :user="edituser"
        :editing.sync="editing"
      />
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import pagination from '@/components/global/pagination'
import User from '@/components/admin/users/User'

export default {
  name: 'UserList',
  components: {
    User
  },
  mixins: [
    pagination
  ],
  data () {
    return {
      users: [],
      edituser: null,
      editing: false,
      pagination: {},
      searchText: '',
      paginationStrings: [
        10, 25, 50
      ],
      headers: [
        { text: 'Name', value: 'last_name' },
        { text: 'Username', value: 'username' },
        {
          text: 'Actions', align: 'center', sortable: false
        }
      ],
      loading: true
    }
  },
  computed: {
    totalUsers () {
      return this.pagination.totalItems
    }
  },
  watch: {
    editing () {
      if (!this.editing) {
        this.edituser = null
        this.fetch()
      }
    }
  },
  methods: {
    fetch () {
      this.loading = true
      api.users.user.list({
        search: this.searchText, ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, pageNum: this.pagination.page, count: this.pagination.rowsPerPage
      })
        .then(data => {
          this.users = data.results
          this.pagination.page = data.page_number
          this.pagination.totalItems = data.count
          this.loading = false
          if (this.$route.params.id && !this.componentCreated) {
            this.editing = true
            this.edituser = this.$route.params.id
          }
          this.componentCreated = true
        })
    },
    addUser () {
      this.editing = true
    },
    edit (user) {
      this.edituser = user
      this.editing = true
    }
  },
  created () {
    this.documentTitle('Users')
  }
}
</script>

<style>

.disabled-user {
  background: #FFCDD2;
}

.search-bar {
  margin-top: 1em;
}

table {
  margin-top: 1em;
}

</style>
